<template>
    <div>
        <div class="modal-header py-2 pt-3"  style="background: #162C4D;">
            <h5 class="text-white">{{$ml.get('CREATE_ACTION_V2')}}</h5>
            <button type="button" id="closeActivity" class="close pb-3 pt-2" style="color: #8092AB;" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" class="font-40">&times;</span>
            </button>
        </div>
        <div class="modal-header py-0" style="background-color: #d7e3f4;">
            <ul class="row nav hpx-50 px-3 mincrm-dynamic-tabs"  role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="process-tab" data-toggle="tab" href="#" role="tab" aria-controls="process" aria-selected="true">{{$ml.get('CREATE_PROCESS')}}  
                    </a>
                </li>
            </ul>
        </div>
        <div class="modal-body">
            <div v-if="!isRender">
                <div class="col-6">
                    <label class="new-label">{{$ml.get('PROCESS_NAME')}}</label>
                    <input type="text" class="new-input" v-model="processName">
                </div>
                <div class="col-6">
                    <label class="new-label">{{$ml.get('FORMS')}}</label>
                    <select class="new-select bg-white" @change="changeForm($event)">
                        <option disabled selected>Select form</option>
                        <option v-for="(form,index) in listForms" :key="index" :value="form._id.$oid" :selected="form._id.$oid == selectedForm">{{form.name}}</option>
                    </select>
                </div>
                <div class="col-6" v-if="isFormSelected">
                    <label class="new-label">{{$ml.get('CHOOSE_STEP')}}</label>
                    <select class="new-select bg-white" @change="changeStep($event)">
                        <option disabled selected>Select step</option>
                        <option v-for="(step,index) in listSteps" :key="index" :value="step.id" :selected="step.id === selectedStep">{{step.name}}</option>
                    </select>
                </div>
                
                <div class="row pt-4 mt-3 crm-modal-footer stickyBtn">
                    <hr class="col-12 d-none d-md-none">
                    <div class="col-12 dealBtnStyle">
                        <button class="btn-new save" @click="proceedRendering">{{$ml.get('PROCEED_V2')}}</button>
                        <button class="btn-new" @click="close()">{{$ml.get('CANCEL')}}</button>
                    </div>
                </div>
            </div>
            <div v-else >
                <div class="scrollable">
                    <FormRenderer :form-configuration="formData" v-model="formInputData"/>
                    <div class="container-fluid pt-2" v-if="isTableAdded">
                        <table-editor :tableName="tableName" :tableData="tableData" :isBuildMode="true" @emitJson="getTableData($event)"></table-editor>  
                    </div>
                </div>
                <div class="row mt-3 crm-modal-footer stickyBtn">
                    <hr class="col-12 d-none d-md-none">
                    <div class="col-12 dealBtnStyle">
                        <button class="btn-new save" @click="getRenderedData">{{$ml.get('PROCEED_V2')}}</button>
                        <button class="btn-new" @click="isRender=false">{{$ml.get('CANCEL')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>  
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import { FormRenderer } from 'v-form-builder'
import TableEditor from './tableEditorTest.vue'


export default {
    name: "workflowProcess",
    components: {
        FormRenderer,
        TableEditor
    },
    props: ['updateAction'],
    data() {
        return {
            listForms: [],
            listSteps: [],
            isFormSelected: false,
            processName: "",
            selectedForm: "",
            selectedStep: "",
            isRender: false,
            isTableAdded: false,
            formInputData: null,
            formData: null,
            tableName: "",
            tableData: [{}],
            processData: {},
            isUpdateMode: false
        };
    },
    computed: {
        ...mapState([
        "baseUrl",
        ]),
    },
    mounted() {
        this.getAllFormsF() 
        if(Object.keys(this.updateAction).length > 0){
            this.isUpdateMode = true
            this.updateWorkflowProcess()
        }
        console.log(this.updateAction);
    },
    created() {
        
    },
    watch: {

    },
    methods: {
        getAllFormsF(){
            axios({
                method:'POST',
                url:'/getAllForms',
                baseURL: this.baseUrl,
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status){
                    if(res.data.status.code==0){
                        this.listForms = res.data.content.forms[0]
                    }
                }else{

                }
            })
        },
        updateWorkflowProcess(){
            let obj = {}
            var inputData = this.updateAction.processInputObj
            this.processName = inputData.name
            this.selectedForm = inputData.form_id
            this.selectedStep = inputData.current_step
            for(let control in inputData.data){
                if(control !== 'tableConfig' ){
                    obj[control] = inputData.data[control]
                    this.formInputData = obj
                }
            }
            this.changeForm(inputData.form_id, 'update')
        },
        changeForm(event, type){
            let stepsArray = [], id
            if(type === 'update'){
                this.selectedForm = event
                id = event
                
            }
            else{
                this.selectedForm = event.target.value
                id = event.target.value
            }
            
            this.getFormF(id)
            console.log(this.listForms);
            
            
            setTimeout(() => {
                for(let form of this.listForms){
                    if(form._id.$oid === id){
                        for(let step of form.flow.sequence){
                            for(let key in form.flow.steps){
                                if(step === key){
                                    stepsArray.push(form.flow.steps[key])
                                }
                            }
                        }
                    }
                }
                this.listSteps = stepsArray
                this.isFormSelected = true
            }, 1000); 
            
            
        },
        changeStep(event){
            this.selectedStep = event.target.value
        },
        proceedRendering(){
            if(this.form.tableObject.tablePermissions){
                this.tableData = this.form.tableObject.tableData
                this.tableName = this.form.tableObject.tableName
                this.isTableAdded = true
            }
            else{
                this.tableData = [{}]
                this.tableName = ""
                this.isTableAdded = false
            }
            this.isRender = true
        },
        getRenderedData(){
            let processObject = {}

            this.$root.$refs.tableEditor.emitJson()

            processObject.current_step = this.selectedStep
            processObject.form_id = this.selectedForm
            processObject.name = this.processName
            processObject.data = this.processData

            this.$emit('change',processObject)
            $('#addAction').modal('hide')
            this.$emit('closeBtnDeal')
        },
        getTableData(data){
            this.tableData = data
            this.processData = this.formInputData
            this.processData['tableConfig'] = data
            
        },
        close(){
            this.$emit('closeBtn')
        },
        getFormF(id){
            axios({
                method:'POST',
                url:'/getForm',
                baseURL: this.baseUrl,
                data:{
                    formId:id
                },
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status){
                    if(res.data.status.code==0){
                        this.form = res.data.content.form
                        this.formData = res.data.content.form.data
                    }
                }
            })
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-header li a {
        color: #93959a;
        text-decoration: none;
        height: 100%;
        display: flex;
        align-items: center;
        padding: 0 13px;
    }
    .modal-header li a.active {
        color: #5b5f63;
        font-weight: bold;
        border-bottom: 3px solid #1991eb;
    }
    .scrollable {
        background-color: #fff;
        padding: 1rem;
        box-sizing: border-box;
        max-height: 700px;
        overflow-y: scroll;
        border: 0.5px solid rgb(235, 235, 235);
    }
    /* Hide scrollbar for Chrome, Safari and Opera */
    .scrollable::-webkit-scrollbar {
        display: none;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    .scrollable {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
</style>
